import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { resolveTheme } from "./themeResolver";
import { buildMuiTheme } from "./createMuiTheme";
import { applyCSSVariables, generateCSSVariables, deepMerge } from "./tokenEngine";
import { useTenant } from "../contexts/TenantService";
import { useThemeMode } from "./useThemeMode";

export const ThemeContext = createContext(null);

export const ThemeProvider = ({ brandId, children }) => {
  const [muiTheme, setMuiTheme] = useState(null);
  const [tokens, setTokens] = useState(null);

  const { tenantSvc } = useTenant();
  const themeMode = useThemeMode();

  useEffect(() => {
    const loadTheme = async () => {
      try {
        const themeTokens = await resolveTheme(brandId, tenantSvc, themeMode);
        const CSSVariables = generateCSSVariables(themeTokens.tenantBase, themeTokens.mode);
        applyCSSVariables(CSSVariables);

        // Merge base and mode into single JSON
        const mergedTokens = deepMerge(themeTokens.tenantBase, themeTokens.mode);
        const theme = buildMuiTheme(mergedTokens);

        setMuiTheme(theme);
        setTokens(mergedTokens);
      } catch (error) {
        console.error("Error loading theme:", error);
      }
    };

    loadTheme();
    document.body.classList.remove("light", "dark");
    document.body.classList.add(themeMode);
  }, [brandId, tenantSvc, themeMode]);

  if (!muiTheme) return null;

  return (
    <ThemeContext.Provider value={{ tokens, mode: themeMode }}>
      <MuiThemeProvider theme={muiTheme}> {children} </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  brandId: PropTypes.string,
  children: PropTypes.node,
};
